import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ScrollBox } from 'components/atoms/ScrollBox';
import { trackContactFiltersEvent } from '../../../services/contacts/filters';
import { Filters } from './filters';
import { defaultFilters } from './defaultFilters';

const FiltersTitleText = styled.div`
  color: ${({ theme }) => theme.colors.text.dark};
  font-weight: 600;
  line-height: 1.4;
  font-size: 16px;
`;

export const ContactsFilters = memo(
  ({
    activeNetwork,
    filters,
    setFilters,
    extendedMode,
    trackingLocation,
    sharedList,
    showListFilters,
    page,
    filtersTitle,
    disableFilterModal,
    sx,
    showTalentNetworkFilters,
  }) => {
    const setMultipleFilters = (group, options = {}) => {
      const { removeFilters = [] } = options;
      const cleanFilters = Object.keys(group).reduce((arr, key) => {
        if (group[key]?.value === 'any' || group[key]?.value === null) {
          removeFilters.push(key);
          return arr;
        }

        arr[key] = group[key]; // eslint-disable-line no-param-reassign
        return arr;
      }, {});
      const newFilters = options?.resetPreviousFilters
        ? { ...defaultFilters, ...cleanFilters }
        : { ...filters, ...cleanFilters };

      [...new Set(removeFilters)].forEach((item) => {
        delete newFilters[item];
      });

      setFilters(newFilters);

      trackContactFiltersEvent({
        group,
        activeNetwork,
        trackingLocation,
        sharedList,
        newFilters,
      });
    };

    return (
      <ScrollBox
        data-testid="contact-filters"
        sx={{
          top: 0,
          height: ['auto', 'auto', '100vh'],
          ...sx,
        }}
      >
        {!!filtersTitle && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              padding: '8px 16px 16px 16px',
            }}
          >
            <FiltersTitleText data-testid="contact-filters-title">{filtersTitle}</FiltersTitleText>
          </div>
        )}
        <div
          style={{
            padding: '0 16px',
            overflowY: 'auto',
            overflowX: 'hidden',
            height: 'calc(100% - 40px)',
            maxHeight: 'calc(100% - 40px)',
          }}
        >
          <Filters
            sharedList={page !== 'list:add' ? sharedList : null}
            filters={filters}
            setFilters={setMultipleFilters}
            extendedMode={extendedMode}
            isTalentNetworkEnabled={!activeNetwork?.tnHidden}
            showListFilters={showListFilters}
            disableFilterModal={disableFilterModal}
            showTalentNetworkFilters={showTalentNetworkFilters}
          />
        </div>
      </ScrollBox>
    );
  },
);

ContactsFilters.propTypes = {
  activeNetwork: PropTypes.object,
  sharedList: PropTypes.object,
  extendedMode: PropTypes.bool,
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  trackingLocation: PropTypes.oneOf(['admin_portal', 'shared_list']),
  showListFilters: PropTypes.bool,
  page: PropTypes.string,
  filtersTitle: PropTypes.string,
  disableFilterModal: PropTypes.bool,
  sx: PropTypes.object,
  showTalentNetworkFilters: PropTypes.bool,
};

ContactsFilters.defaultProps = {
  activeNetwork: {},
  sharedList: null,
  extendedMode: false,
  trackingLocation: 'admin_portal',
  showListFilters: true,
  filtersTitle: '',
  disableFilterModal: false,
  sx: {},
  showTalentNetworkFilters: false,
  page: 'all_contacts',
};
